module.exports = __webpack_public_path__ + "img/data-item5-1.c11feff.png";